import PropTypes from 'prop-types';
import React from 'react';

import {
  ErrorDetails,
  ErrorPre,
  FallbackContainer,
} from './MapErrorBoundary.styles';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Store error details in state for debugging
    this.setState({
      error,
      errorInfo,
    });

    // Optional: Send error to logging service
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Render fallback component
      return (
        this.props.fallback || (
          <FallbackContainer>
            <h3>Map Display Error</h3>
            <p>
              Unable to load the interactive map. Please try refreshing the
              page.
            </p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <ErrorDetails>
                <summary>Error Details (Development Only)</summary>
                <ErrorPre>
                  {this.state.error.toString()}
                  {this.state.errorInfo.componentStack}
                </ErrorPre>
              </ErrorDetails>
            )}
          </FallbackContainer>
        )
      );
    }

    return this.props.children;
  }
}

MapErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  onError: PropTypes.func,
};

export default MapErrorBoundary;
